






















import {Component, Prop, Vue} from "vue-property-decorator";
import FileUpload from "@/components/common/FileUpload.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import {namespace} from "vuex-class";
import PayrollService from "@/services/payroll/PayrollService";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";

const AppModule = namespace("App");

@Component({
  components: {FileUpload, PortalInput}
})
export default class Upload1042Modal extends Vue {

  @AppModule.State
  private loading!: boolean;

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  @Prop()
  private onFilesUploaded!: () => void;

  @Prop()
  private companyId!: number;

  private period = "";

  private isPeriodEntered = false;

  onUploaded(files: FileMetaDTO[]) {
    Application.startLoading();
    PayrollService.saveForm1042({
      companyId: this.companyId,
      fileMetaId: files[0].id,
      year: this.period
    }).then(
        ok => {
          Application.stopLoading();
          this.onFilesUploaded();
          this.$modal.hideAll();
        },
        err => processError(err, this)
    )
  }
}
